import React, { useState, useEffect} from 'react';
import { db} from './firebase';
import { useAuth} from './AuthContext';
import {
  collection, where,
  query,
  onSnapshot,
  setDoc,
  doc,
  serverTimestamp
} from 'firebase/firestore';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { customAlphabet } from 'nanoid';
import './GroupList.css';

// Audio Assets

const nanoid = customAlphabet('1234567890ABCDEF', 6);

export default function GroupList() {
 const [groups, setGroups] = useState([]);
  const [newGroupName, setNewGroupName] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
useEffect(() => {
    if (!user?.uid) return;
    const q = query(
      collection(db, 'groups'), 
      where('memberIds', 'array-contains', user.uid)
    );
    return onSnapshot(q, (snap) => {
      setGroups(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, [user?.uid]);

  const handleCreateGroup = async (e) => {
    e.preventDefault();
    if (!newGroupName.trim()) return;

    try {
      const groupId = nanoid();
      await setDoc(doc(db, 'groups', groupId), {
        id: groupId,
        name: newGroupName,
        ownerId: user.uid,
        // 🌟 ADD THIS: Save the name explicitly
      ownerName: user.displayName || 'Anonymous',
        memberIds: [user.uid],
        memberEmails: [user.email.toLowerCase()],
        settings: { allowAllCreate: true, allowAllEdit: true },
        createdAt: serverTimestamp(),
        metadata: { coverColor: '#CFFF04' }
      });
      setShowCreate(false);
      navigate(`/groupslist/${groupId}/${user.uid}`);
    } catch (err) { console.error(err); }
  };
  return (
    <div className="group-page">
      <header className="group-header">
        <h1 className="lore-title">
          GROWTH <span>CIRCLES</span>
        </h1>
        <button className="create-trigger" onClick={() => setShowCreate(true)}>
          + NEW CIRCLE
        </button>
      </header>

      {/* CREATE MODAL */}
      <AnimatePresence>
        {showCreate && (
          <motion.div className="modal-overlay">
            <motion.form
              className="create-card"
              onSubmit={handleCreateGroup}
              initial={{ y: 50 }}
              animate={{ y: 0 }}
              exit={{ y: 50 }}
            >
              <h2>START A LORE CIRCLE</h2>
              <input
                value={newGroupName}
                onChange={(e) => setNewGroupName(e.target.value)}
                placeholder="Circle Name..."
                autoFocus
              />
              <div className="modal-actions">
                <button type="button" onClick={() => setShowCreate(false)}>
                  CANCEL
                </button>
                <button type="submit">
                  CREATE
                </button>
              </div>
            </motion.form>
          </motion.div>
        )}
      </AnimatePresence>

      {/* GROUP GRID */}
      <div className="group-grid">
        {groups.map(group => (
          <motion.div
            key={group.id}
            className="group-card"
            whileHover={{ y: -5 }}
          >
            <div
              className="group-tag"
              style={{ background: group.metadata?.coverColor }}
            />
            <h3>{group.name}</h3>
           <p>Created by {group.ownerName || 'Unknown'}</p>
            <button onClick={() => navigate(`/groupslist/${group.id}/${user.uid}`)}>
      ENTER CIRCLE
    </button>
          </motion.div>
        ))}
      </div>

    </div>
  );
}
